<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>

                    <b-card-header>
                        <span class="h5">RATEIOS</span>
                        <div>
                            <b-button
                                class="float-right"
                                variant="primary"
                                :disabled="desabilitarSalvar"
                                @click.stop="confirmarSalvar()"
                            >
                                <i class="fa fa-floppy-o"></i> Salvar
                            </b-button>
                            <btn-inserir-dotacao-em-massa
                                class="float-right mr-2"
                                :percentualASerRateado="percentualASerRateado"
                                :percentualDisponivel="percentualDisponivel"
                                @inserirRateio="inserirRateio($event)"
                                @obterUnidades="$emit('obterUnidades')"
                                @obterProjetos="$emit('obterProjetos', $event)"
                                @obterAcoes="$emit('obterAcoes', $event)"
                                :unidades="unidades"
                                :projetos="projetos"
                                :acoes="acoes"
                            ></btn-inserir-dotacao-em-massa>
                        </div> 
                    </b-card-header>
                    <b-card-body>
                        <tabela-ajuste-rateios-em-massa
                            :rateios="rateios"
                            :percentualASerRateado="percentualASerRateado"
                            :percentualRateado="percentualRateado"
                            :percentualDisponivel="percentualDisponivel"
                            @atualizarRateio="atualizarRateio($event)"
                            @excluirRateio="excluirRateio($event)"
                        ></tabela-ajuste-rateios-em-massa>
                    </b-card-body>

                </b-card>
            </b-col>
        </b-row>       
    </div>
</template>

<script>
import BtnInserirDotacaoEmMassa from './BtnInserirDotacaoEmMassa.vue';
import TabelaAjusteRateiosEmMassa from './TabelaAjusteRateiosEmMassa.vue';

export default {
    props: {
        unidades: {
            type: Array
        },

        projetos: {
            type: Array
        },

        acoes: {
            type: Array
        },

        temItensSelecionados: {
            type: Boolean,
            default: () => false
        }
    },

    components: {
        BtnInserirDotacaoEmMassa,
        TabelaAjusteRateiosEmMassa
    },

    data() {
        return {
            rateios: [],
        }
    },

    methods: {
        confirmarSalvar() {
            if (this.$route.name == 'DespesasGerais_Finalizacao_Despesas_Detalhar') {
                this.confirmarSalvarUABS()
            } else {
                this.confirmarSalvarReq()
            }
        },

        confirmarSalvarReq() {
            this.$swal({
                title: 'Rateios',
                html: `Confirma as alterações em massa no rateio dos itens?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    let rateiosDto = {
                        rateios: this.rateios
                    }
                    this.$emit('salvarRateios', rateiosDto)
                }
            })
        },
        
        confirmarSalvarUABS() {
            this.$swal({
                title: 'Rateios',
                html: `Confirma as alterações em massa no rateio dos itens?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da reprovação',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa da reprovação é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    let rateiosDto = {
                        justificativa: result.value,
                        rateios: this.rateios
                    }
                    this.$emit('salvarRateios', rateiosDto)
                }
            })
        },

        inserirRateio(rateio) {
            if (
                this.rateios.filter(r => {
                    return (
                        r.codUnidade == rateio.codUnidade &&
                        r.codProjeto == rateio.codProjeto &&
                        r.codAcao == rateio.codAcao
                    )
                }).length > 0
            ) {
                this.erroNaInclusaoDotacao()
            } else {
                this.rateios.push(rateio)
            }
        },

        erroNaInclusaoDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Já existe dotação com a unidade/projeto/ação informados`,
                icon: 'error'
            })
        },

        atualizarRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateios[index].percentual = rateio.percentual
                    break
                }
            }
        },

        excluirRateio(rateio) {
            for (let index = 0; index < this.rateios.length; index++) {
                const rateioAtual = this.rateios[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateios.splice(index, 1)
                    break
                }
            }
        },

    },

    computed: {
        desabilitarSalvar() {
            return this.percentualDisponivel > 0 
                || !this.temItensSelecionados
        },

        percentualASerRateado() {
            return 100
        },

        percentualRateado() {
            if (this.rateios != null) {
                return Number.parseFloat(
                    this.rateios
                    .map(item => {
                        return item.percentual
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(5)
                    )
            }
            return 0
        },

        percentualDisponivel() {
            return Number.parseFloat(
                (this.percentualASerRateado - this.percentualRateado).toFixed(5)
            )
        },
    }

}

</script>